import React from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    className?: string;
}

const GradientBGContainer: React.FC<Props> = ({ children, className }) => {
    return (
        <div className={`bg-primary text-accent p-4 ${className}`}>
            {children}
        </div>
    );
};

export default GradientBGContainer;